import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ExceptionItem, ExceptionHistoryItem, FilterValues, RequestPageParams } from '@shared/models';

export const ExceptionManagementActions = createActionGroup({
  source: 'Exception Management',
  events: {
    'Load Exceptions': props<{ params: RequestPageParams }>(),
    'Load Exceptions Success': props<{ exceptionListItems: ExceptionItem[]; totalElements: number }>(),
    'Load Exceptions Failure': props<{ error: string }>(),
    'Set Exceptions Active Filters': props<{ filters: FilterValues }>(),
    'Set Exceptions Assignee Filter': props<{ assigneeFilter: { label: string; value: string }[] }>(),
    'Load Exception Details': emptyProps,
    'Load Exception Details Success': props<{ exceptionDetails: ExceptionItem }>(),
    'Load Exception Details Failure': props<{ error: string }>(),
    'Update Exception': props<{ data: { assignedTo?: string; status?: string } }>(),
    'Update Exception Success': props<{ exceptionDetails: ExceptionItem }>(),
    'Update Exception Failure': props<{ error: string }>(),
    'Load Exception History': props<{ params: RequestPageParams; businessAccountId: string }>(),
    'Load Exception History Success': props<{
      businessAccountId: string;
      exceptionHistoryItems: ExceptionHistoryItem[];
      totalElements: number;
    }>(),
    'Load Exception History Failure': props<{ error: string }>(),
  },
});
